var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"loading-spinner"},_vm._l((12),function(i){return _c('div',{key:i,class:['circle-' + i]})}),0)}
var staticRenderFns = []

export { render, staticRenderFns }